import { Typography, Box, useTheme, useMediaQuery, Grid2 } from "@mui/material";
import { LandingPageSection } from "../../components/static-page-components/landing-page-section";
import reviewDesktop from "../../assets/home-owner/images/review-desktop.png";
import reviewMobile from "../../assets/home-owner/images/review-mobile.png";

export const WhyHDGSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const reviewImage = isMobile ? reviewMobile : reviewDesktop;

  return (
    <LandingPageSection id="be-informed" sx={{ px: { xs: 0, md: 0 }}}>
      <Grid2 container columns={12} spacing={{ xs: '40px', md: "64px" }} direction={{ xs: 'column-reverse', md: 'row' }}>
        <Grid2
          size={{ xs: 12, md: 6 }}
          sx={{ overflowX: "auto", overflowY: "hidden" }}
        >
          <Box className="section-image">
            <img src={reviewImage} alt="review" className="full-width-image" />
          </Box>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }} alignContent={"center"} sx={{ px: { xs: 4, md: 0 }}}>
          <Typography variant="overline" className="section-sub-heading section-subtitle">
            why home design guild
          </Typography>
          <Typography
            variant={"display2" as any}
            component="h2"
            className="section-title text-pink"
            mb="16px"
            fontWeight={700}
          >
            NOT JUST ANOTHER PRETTY SPACE
          </Typography>
          <Typography
            variant="body1"
            className=" font-size-3 contain-text"
            sx={{ mb: { xs: 0, md: 3 } }}
            lineHeight={{ xs: "24px", md: "28px" }}
          >
            Stop the project doom scrolling and google searching. You deserve better, we've designed a great way for you to find your dream designer, feel confident and stress less.
          </Typography>
        </Grid2>
      </Grid2>
    </LandingPageSection>
  );
}; 